module.exports = __webpack_public_path__ + "img/intro-bg.a5390966.png";